export const BACK_ROUTES_PATH = [
  { route: '/purchase/create/', route_to_redirect: '/purchase/list/' },
  {
    route: '/purchase/edit/',
    route_to_redirect: '/purchase/list/',
  },
  {
    route: '/sales/edit/',
    route_to_redirect: '/sales/list/',
  },
  {
    route: '/purchase/return/create/',
    route_to_redirect: '/purchase/return/list/',
  },

  {
    route: '/opening/stock-adjustment/create/',
    route_to_redirect: '/transaction/stock-adjustment/list/',
  },
  {
    route: '/purchase/return/edit/',
    route_to_redirect: '/purchase/return/list/',
  },
  {
    route: '/sales/create/',
    route_to_redirect: '/sales/list/',
  },

  {
    route: '/sales/order/edit/',
    route_to_redirect: '/sales/order/list/',
  },
  {
    route: '/sales/return/edit/',
    route_to_redirect: '/sales/return/list/',
  },

  {
    route: '/sales/order/create/',
    route_to_redirect: '/sales/order/list/',
  },
  {
    route_to_redirect: '/sales/return/list/',
    route: '/sales/return/create/',
  },
  {
    route_to_redirect: '/issues/karigar/list/',
    route: '/issue/karigar/create/',
  },
  {
    route_to_redirect: '/issues/karigar/list/',
    route: '/issue/karigar/edit/',
  },
  {
    route_to_redirect: '/issues/refine/list/',
    route: '/issue/refine/create/',
  },
  {
    route_to_redirect: '/issues/refine/list/',
    route: '/issue/refine/edit/',
  },
  {
    route_to_redirect: '/issues/party/list/',
    route: '/issue/party/create/',
  },
  {
    route_to_redirect: '/issues/party/list/',
    route: '/issue/party/edit/',
  },
  {
    route_to_redirect: '/receives/karigar/list/',
    route: '/receive/karigar/create/',
  },
  {
    route_to_redirect: '/receives/karigar/list/',
    route: '/receive/karigar/edit/',
  },
  {
    route_to_redirect: '/receives/refine/list/',
    route: '/receive/refine/create/',
  },
  {
    route_to_redirect: '/receives/refine/list/',
    route: '/receive/refine/edit/',
  },

  {
    route_to_redirect: '/receives/party/list/',
    route: '/receive/party/create/',
  },
  {
    route_to_redirect: '/receives/party/list/',
    route: '/receive/party/edit/',
  },
  {
    route_to_redirect: '/opening/stock/list/',
    route: '/opening/stock/create/',
  },
  {
    route_to_redirect: '/opening/stock/list/',
    route: '/opening/stock/edit/',
  },
  {
    route_to_redirect: '/contra/voucher/list/',
    route: '/contra/voucher/create/',
  },
  {
    route_to_redirect: '/journal/voucher/list/',
    route: '/journal/voucher/create/',
  },
  {
    route_to_redirect: '/receipt/voucher/list/',
    route: '/receipt/voucher/create/',
  },
  {
    route_to_redirect: '/metal-to/cash/list/',
    route: '/metal-to/cash/create/',
  },
  {
    route_to_redirect: '/accounting/cash-to-metals/list/',
    route: '/metal-to/cash/create/',
  },
  {
    route_to_redirect: '/ledger/reports/',
    route: '/ledger-details/reports/',
  },
  {
    route_to_redirect: '/sundry-creditors/reports/',
    route: '/sundry-ledger-details/reports/',
  },

  {
    route_to_redirect: '/sundry-debtors/reports/',
    route: '/debtors-ledger-details/reports/',
  },

  {
    route_to_redirect: '/reports/',
    route: '/sundry-debtors/reports/',
  },

  {
    route_to_redirect: '/reports/',
    route: '/sundry-creditors/reports/',
  },

  {
    route_to_redirect: '/reports/',
    route: '/ledger/reports/',
  },

  {
    route_to_redirect: '/stock/detail/report/',
    route: '/stock/ledger/report/',
  },

  {
    route_to_redirect: '/stock-summary/reports/',
    route: '/stock/detail/report/',
  },

  {
    route_to_redirect: '/reports/',
    route: '/stock-summary/reports/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/sales/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/opening/stock/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/purchase/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/sales/order/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/sales/return/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/purchase/return/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/issues/karigar/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/issues/refine/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/issues/party/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/receives/karigar/list/',
  },

  {
    route_to_redirect: '/reports/',
    route: '/ledger/cash-bank/reports/',
  },

  {
    route_to_redirect: '/ledger/cash-bank/reports/',
    route: '/cash-bank-ledger-details/reports/',
  },

  {
    route_to_redirect: '/ledger/karigar/reports/',
    route: '/karigar/ledger-details/reports/',
  },

  {
    route_to_redirect: '/reports/',
    route: '/ledger/karigar/reports/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/receives/refine/list/',
  },

  {
    route_to_redirect: '/sub-dashboard/',
    route: '/receives/party/list/',
  },
];
